import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import {
  VariantAttributeDto,
  CreateVariantAttributeRequest,
  AddVariantAttributeValueRequest,
  UpdateVariantAttributeRequest,
} from '../models/variant.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class VariantAttributeService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/variant-attributes`;

  getAll(
    search?: string,
    includeInactive = false,
    storeTypeId?: string | null,
  ): Observable<ApiResponse<VariantAttributeDto[]>> {
    let params = new HttpParams().set('includeInactive', includeInactive);
    if (search) params = params.set('search', search);
    if (storeTypeId) params = params.set('storeTypeId', storeTypeId);
    return this.http.get<ApiResponse<VariantAttributeDto[]>>(this.endpoint, { params });
  }

  create(data: CreateVariantAttributeRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.endpoint, data);
  }

  update(id: string, data: UpdateVariantAttributeRequest): Observable<ApiResponse<unknown>> {
    return this.http.put<ApiResponse<unknown>>(`${this.endpoint}/${id}`, data);
  }

  addValue(
    attributeId: string,
    data: AddVariantAttributeValueRequest,
  ): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(
      `${this.endpoint}/${attributeId}/values`,
      data,
    );
  }

  delete(id: string): Observable<ApiResponse<unknown>> {
    return this.http.delete<ApiResponse<unknown>>(`${this.endpoint}/${id}`);
  }
}
